export const CLAUSE_TYPE_COMPOUND = 'compound';
export const CLAUSE_TYPE_TERMINAL = 'terminal';
export const CLAUSE_TYPE_NOT = 'not';
